<template>
    <div class="computerBox">
        <topBox :title="title" />
        <div class="px-[36px] w-full mt-[80px]">

            <p class="mb-4 text-14 text-slate-400 leading-relaxed">{{ $t('text.inviteLinkTip') }}</p>

            <div class="my-2">
                <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('but.downloadQr') }}</h1>
                <div class="flex flex-col items-center rounded-[24px] border bg-white p-6 shadow-lg">
                    <canvas ref="qrCanvas" class="block h-[200px] w-[200px]"></canvas>
                </div>
                <div class="mt-3 py-[10px]">
                    <button
                        type="button"
                        class="block w-full px-5 py-[15px] border rounded-full butSubmit text-white shadow-lg focus:ring-1 focus:outline-none text-xs-xs"
                        @click="downloadQr"
                    >
                        {{ $t('but.downloadQr') }}
                    </button>
                </div>
            </div>

            <div class="my-2 ">
                <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('text.inviteRegisterLink') }}</h1>
                <input
                    ref="inviteInput"
                    type="text"
                    readonly
                    class="block w-full px-[35px] py-[15px] border rounded-full bg-white shadow-lg text-gray-700 focus:ring-1 focus:outline-none text-ms"
                    :value="inviteUrl"
                />
                <div class="mt-3 py-[10px] mb-12">
                    <button
                        type="button"
                        class="block w-full px-5 py-[15px] border rounded-full shadow-lg focus:ring-1 focus:outline-none text-xs-xs transition-colors"
                        :class="copied ? 'bg-slate-100 text-green-600' : 'butSubmit text-white'"
                        @click="copyLink"
                    >
                        {{ copied ? $t('but.copied') : $t('but.copy') }}
                    </button>
                </div>
            </div>



        </div>
        <mainMenu />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import QRCode from 'qrcode'
import topBox from '@/components/computer/TopBox.vue'
import mainMenu from '@/components/computer/MainMenu.vue'
import axios from 'axios'
import { layer } from 'vue3-layer'
// 使用全局变量
import { useGlobalStore } from '@/assets/js/globalStore'


export default {
    components: {
        topBox,
        mainMenu,
    },
    data() {
        return {
            title: this.$t('page.inviteLink'),
            lang: '',
            inviteCode: '',
            inviteUrl: '',
            copied: false,
            copyTimer: null,
        }
    },
    setup() {
        const token = localStorage.getItem('token') ? localStorage.getItem('token') : false
        return {
            token
        }
    },
    mounted() {
        const { locale } = useI18n()
        this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : locale.value
        locale.value = this.lang
        this.$route.params.id
        console.log(`id ` + this.$route.params.id + ` token ` + this.token)
        this.getInfo()
    },
    beforeUnmount() {
        if (this.copyTimer) {
            clearTimeout(this.copyTimer)
        }
    },
    methods: {
        getInfo() {
            axios.post(
                '/api/m/info/user',
                {},
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        token: localStorage.getItem('token'),
                    },
                }
            )
            .then((response) => {
                if (response.data.code === 0) {
                    this.inviteCode = response.data.data.uuid || ''
                    const globalStore = useGlobalStore()
                    // 邀请码用帐号 uuid，写入 store 供播放页等复用
                    if (this.inviteCode) {
                        globalStore.setId(this.inviteCode)
                    }
                    this.buildInviteUrl()
                    this.$nextTick(() => this.renderQr())
                } else {
                    layer.msg(response.data.msg)
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },
        buildInviteUrl() {
            const base = window.location.origin
            const videoId = this.$route.params.id
            // 必须用当前登录用户的 uuid（inviteCode），不能用 globalStore.id：
            // 后者可能从未赋值，模板字符串会变成字面量 "undefined"
            if (!videoId || !this.inviteCode) {
                this.inviteUrl = ''
                return
            }
            this.inviteUrl = `${base}/computer/play/video/${videoId}/${this.inviteCode}`
        },
        renderQr() {
            const canvas = this.$refs.qrCanvas
            if (!canvas || !this.inviteUrl) return
            QRCode.toCanvas(canvas, this.inviteUrl, {
                width: 200,
                margin: 2,
                color: {
                    dark: '#22c55e',
                    light: '#ffffff',
                },
            }).catch((err) => {
                console.log(err)
            })
        },
        copyLink() {
            const text = (this.inviteUrl || '').trim()
            if (!text) {
                layer.msg(this.$t('text.copyFailed'))
                return
            }

            const done = () => {
                this.copied = true
                if (this.copyTimer) clearTimeout(this.copyTimer)
                this.copyTimer = setTimeout(() => {
                    this.copied = false
                }, 2000)
                layer.msg(this.$t('text.copySuccess'))
            }

            // 1) 优先选中页面上已有的只读输入框再 execCommand。
            //    本站多为 http://（非安全上下文），Clipboard API 常不可用或会静默失败。
            if (this.copyFromVisibleInput()) {
                done()
                return
            }

            // 2) HTTPS / localhost 才尝试异步 Clipboard API
            if (window.isSecureContext && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(done).catch(() => {
                    if (this.fallbackCopy(text)) {
                        done()
                    } else {
                        layer.msg(this.$t('text.copyFailed'))
                    }
                })
                return
            }

            // 3) 临时 textarea 兜底（兼容部分 WebView）
            if (this.fallbackCopy(text)) {
                done()
            } else {
                layer.msg(this.$t('text.copyFailed'))
            }
        },
        /** 从可见输入框复制，返回是否成功 */
        copyFromVisibleInput() {
            const input = this.$refs.inviteInput
            if (!input || !input.value) return false
            try {
                input.focus()
                input.select()
                input.setSelectionRange(0, input.value.length)
                return document.execCommand('copy')
            } catch (e) {
                return false
            }
        },
        /** 临时节点复制，返回是否成功（须检查 execCommand 返回值，不能假定成功） */
        fallbackCopy(text) {
            const input = document.createElement('textarea')
            input.value = text
            input.setAttribute('readonly', 'readonly')
            input.style.position = 'fixed'
            input.style.top = '0'
            input.style.left = '0'
            input.style.width = '1px'
            input.style.height = '1px'
            input.style.padding = '0'
            input.style.border = 'none'
            input.style.outline = 'none'
            input.style.boxShadow = 'none'
            input.style.background = 'transparent'
            document.body.appendChild(input)
            input.focus()
            input.select()
            input.setSelectionRange(0, text.length)
            let ok = false
            try {
                ok = document.execCommand('copy')
            } catch (e) {
                ok = false
            }
            document.body.removeChild(input)
            return ok
        },
        downloadQr() {
            const canvas = this.$refs.qrCanvas
            if (!canvas) return
            const link = document.createElement('a')
            link.download = `invite-${(this.inviteCode || 'qr').slice(0, 8)}.png`
            link.href = canvas.toDataURL('image/png')
            link.click()
        },
    },
}
</script>

<style lang="scss" scoped>
.computerBox {
    /* background: url('https://tdkt06.com/img/headbg2x.1c5aca6e.png') 0% 0% / 100% no-repeat; */
}
</style>
